const KEY = 'clientId';

function isValidClientId(n: unknown): n is number {
    return typeof n === 'number' && Number.isInteger(n) && n > 0;
}

export function getTabClientId(): number | null {
    if (typeof sessionStorage === 'undefined') return null;
    const v = sessionStorage.getItem(KEY);
    if (!v) return null;
    const n = Number(v);
    return isValidClientId(n) ? n : null;
}

export function setTabClientId(clientId: number | null | undefined): void {
    if (typeof sessionStorage === 'undefined') return;
    if (!isValidClientId(clientId)) {
        sessionStorage.removeItem(KEY);
    } else {
        sessionStorage.setItem(KEY, String(clientId));
    }
}
